import { useState, useCallback } from 'react';
import { forceLogout } from '../utils/auth/forceLogout';

export function useForceLogout() {
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleForceLogout = useCallback(async () => {
    if (isLoggingOut) return;
    
    try {
      setIsLoggingOut(true);
      await forceLogout();
    } catch (error) {
      console.error('Force logout error:', error);
      // Force reload even on error
      window.location.href = `${window.location.origin}?clear=${Date.now()}`;
    }
  }, [isLoggingOut]);

  return { handleForceLogout, isLoggingOut };
}